<template>
    <div>
        <div v-if="$store.state.healthyHabits.table.data.items && $store.state.healthyHabits.table.data.items.length > 0 && !$store.state.healthyHabits.form.editing">
            <h3 class="type-habit-title my-4">{{$t('selectHabitType')}}</h3>
            <healthy-habits-predefined showingInForm @predefinedHabitSelected="loadPredefinedHabit()"></healthy-habits-predefined>
        </div>
        <div v-if="!$store.state.healthyHabits.form.editing">
            <h3 class="type-habit-title my-4">{{$store.state.healthyHabits.table.data.items && $store.state.healthyHabits.table.data.items.length > 0 ? $t('createOwnHabit') : $t('selectHabitType')}}</h3>
            <div class="type-habit-options-box">
                <base-card name="measurable-option" @click="healthyHabitTypeSelected(true); $store.state.healthyHabits.predefinedHabit.itemIdSelected = null" style="z-index: 1;" :class="{'type-habit-option-selected': healthyHabitsData.measurable === true, 'type-habit-card': true, 'mr-3': true}"><span class="card-form-content"><span>{{$t('measurable')}}</span><br><span class="frequency-options-examples">{{$t('measurableExamples')}}</span></span></base-card>
                <base-card name="no-measurable-option" @click="healthyHabitTypeSelected(false); $store.state.healthyHabits.predefinedHabit.itemIdSelected = null" :class="{'type-habit-option-selected': healthyHabitsData.measurable === false, 'type-habit-card': true}"><span class="card-form-content"><span>{{$t('notmeasurable')}}</span><br><span class="frequency-options-examples">{{$t('notMeasurableExamples')}}</span></span></base-card>
            </div>
        </div>
        <div v-if="healthyHabitsData.measurable != null">
            <base-card :class="{row: true, 'type-habit-form-box': true, 'width-95': !this.inModal}">
                <b-row style="width: 100%">
                    <b-col class="margin-bottom-form px-2" cols="12">{{$t('color')}}: <input class="cursor-pointer" v-model="healthyHabitsData.color" type="color"></b-col>
                    <b-col class="px-2" cols="12"><base-input @blur="state.description = healthyHabitsData.description ? true : false" :state="state.description" v-model="healthyHabitsData.description" :placeholder="healthyHabitsData.measurable ? $t('nameFormMeasurablePlaceholder') : $t('nameFormPlaceholder')"></base-input></b-col>
                    <!-- <b-col class="px-2" cols="12"><base-input @blur="state.question = healthyHabitsData.question ? true : null" :state="state.question" v-model="healthyHabitsData.question" :placeholder="`${healthyHabitsData.measurable ? $t('questionFormMeasurablePlaceholder') : $t('questionFormPlaceholder')} ${$t('optional')}`"></base-input></b-col> -->
                    <b-col class="px-2" v-if="healthyHabitsData.measurable" cols="12"><base-input @blur="state.goal = healthyHabitsData.goal > 0" :state="state.goal" v-model="healthyHabitsData.goal" :readonly="isMultiUser" :name="isMultiUser ? 'readonlymultiuser' : ''" :type="isMultiUser ? 'text' : 'number'" :min="0" :step="1" :placeholder="$t('goalFormPlaceholder')"></base-input></b-col>
                    <b-col class="px-2" v-if="healthyHabitsData.measurable" cols="12"><base-input @blur="state.measureUnit = healthyHabitsData.measureUnit ? true : false" :state="state.measureUnit" :readonly="isMultiUser" :name="isMultiUser ? 'readonlymultiuser' : ''" v-model="healthyHabitsData.measureUnit" :placeholder="$t('UnitFormPlaceholder')"></base-input></b-col>
                    <b-col class="px-2" cols="12" @click.stop="isMultiUser ? showFrequencyModal = showFrequencyModal : showFrequencyModal = true"><base-input :state="state.goalFrequencyId" :name="isMultiUser ? 'readonlymultiuser' : ''" readonly v-model="frequencyText" :placeholder="$t('frequency')"></base-input></b-col>
                    <b-col class="px-2" cols="12">
                        <b-input-group class="reminder-input-form" style="margin-bottom: 1.5rem">
                            <b-input-group-prepend>
                                <b-input-group-text><b-icon-bell></b-icon-bell></b-input-group-text>
                            </b-input-group-prepend>
                            <div class="reminder-container form-control">
                                <vue-clock-picker id="reminder-clock-selector" :active-color="healthyHabitsData.color" :done-text="$t('save')" @timeset="showReminderDaysInput = true" @beforeOpen="setDefaultTime" @cancel="resetReminder" :cancel-text="$t('reset')" input-class="clock-selector-input" :placeholder="`${$t('reminder')} ${$t('optional')}`" v-model="healthyHabitsData.reminder"></vue-clock-picker>
                            </div>
                            <b-input-group-append>
                                <b-input-group-text class="cursor-pointer" @click="resetReminder"><b-icon-trash></b-icon-trash></b-input-group-text>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col class="px-2" v-if="showReminderDaysInput" cols="12" @click.stop="showReminderDaysModal = true">
                        <b-input-group class="reminder-input-form" style="margin-bottom: 1.5rem">
                            <b-input-group-prepend>
                                <b-input-group-text><b-icon-bell></b-icon-bell></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input readonly v-model="reminderDaysText" :placeholder="$t('reminderDays')"></b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col class="px-2" cols="12"><base-textarea noResize :maxRows="10" :rows="1" @blur="state.notes = healthyHabitsData.notes ? true : null" :state="state.notes" v-model="healthyHabitsData.notes" :placeholder="`${$t('notes')} ${$t('optional')}`" :readOnly="!!$route.params.t"></base-textarea></b-col>
                    <b-col v-if="!$store.state.healthyHabits.form.editing" class="px-2" cols="12"><b-form-checkbox class="form-group" @change="switchInviteMultiUser" switch v-model="$store.state.healthyHabits.form.multiUser"><span v-html="$t('invitePatientsMultiUser')"></span> <b-icon-question-circle @click.prevent v-b-tooltip.hover v-b-tooltip.click="$t('inviteMultiUserInfo')" :title="$t('inviteMultiUserInfo')"></b-icon-question-circle></b-form-checkbox></b-col>
                    <b-col class="px-2" cols="12"><v-select v-if="$store.state.healthyHabits.form.multiUser" v-model="healthyHabitsData.multiUsersEmailsOrPhones" multiple taggable :placeholder="$t('typeUserEmailsOrPhones')" label="name">
                    <template #no-options="">
                        <span>{{$t('typePatientEmailOrPhoneAdvice')}}(&#9166;)</span>
                    </template>
                    </v-select></b-col>
                    <b-col class="text-center" cols="12"><base-button class="mr-1 my-1" @click="sendData()">{{$t('save')}}</base-button><base-button @click="cancel()" gray>{{$t('back')}}</base-button></b-col>
                </b-row>
            </base-card>
            <base-modal noCloseOnBackdrop noCloseOnScape hideClose titleAlignLeft :value="showFrequencyModal" :title="$t('selectAnOption')" @hide="showFrequencyModal = false">
                <b-form-group :class="{'no-margin-bottom': !healthyHabitsData.measurable}" label="" v-slot="{ ariaDescribedby }">
                    <b-form-radio plain class="my-2" v-if="healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="1">{{$t('daily')}}</b-form-radio>
                    <b-form-radio plain class="my-2" v-if="healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="2">{{$t('weekly')}}</b-form-radio>
                    <b-form-radio plain class="my-2" v-if="healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="3">{{$t('monthly')}}</b-form-radio>
                    <b-form-radio plain class="my-2" v-if="!healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="1">{{$t('each')}} <base-input @click="healthyHabitsData.goalFrequencyId = 1" class="input-modal-options" placeholder="" v-model="goalDays" type="number" :min="1" :max="90"></base-input> {{$t('days')}} <b-icon-question-circle @click.prevent v-b-tooltip.hover v-b-tooltip.click="`${$t('valuesBetween')} 1 y 90`" :title="`${$t('valuesBetween')} 1 y 90`"></b-icon-question-circle></b-form-radio>
                    <b-form-radio plain class="my-2" v-if="!healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="2"><base-input @click="healthyHabitsData.goalFrequencyId = 2" class="input-modal-options" placeholder="" v-model="goalWeek" type="number" :min="1" :max="6"></base-input> {{$t('timesToWeek')}} <b-icon-question-circle @click.prevent v-b-tooltip.hover v-b-tooltip.click="`${$t('valuesBetween')} 1 y 6`" :title="`${$t('valuesBetween')} 1 y 6`"></b-icon-question-circle></b-form-radio>
                    <b-form-radio plain class="my-2" v-if="!healthyHabitsData.measurable" v-model="healthyHabitsData.goalFrequencyId" :aria-describedby="ariaDescribedby" name="frequency-radio" :value="3"><base-input @click="healthyHabitsData.goalFrequencyId = 3" class="input-modal-options" placeholder="" v-model="goalMonth" type="number" :min="1" :max="29"></base-input> {{$t('timesToMonth')}} <b-icon-question-circle @click.prevent v-b-tooltip.hover v-b-tooltip.click="`${$t('valuesBetween')} 1 y 29`" :title="`${$t('valuesBetween')} 1 y 29`"></b-icon-question-circle></b-form-radio>
                </b-form-group>
                <div><base-button @click="saveFrequency">{{$t('save')}}</base-button></div>
            </base-modal>
            <base-modal noCloseOnBackdrop noCloseOnScape hideClose titleAlignLeft :value="showReminderDaysModal" :title="$t('selectOneMoreOption')" @hide="showReminderDaysModal = false">
                <b-form-checkbox-group class="form-group" :stacked="showWeekDaysStacked" v-model="reminderDaysArray" :options="weekDaysOptions" value-field="value" text-field="name"></b-form-checkbox-group>
                <div><base-button @click="saveReminderDays">{{$t('save')}}</base-button></div>
            </base-modal>
        </div>
    </div>
</template>

<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import BaseCard from '@/components/base/ui/BaseCard'
import BaseInput from '@/components/base/forms/BaseInput'
import BaseTextArea from '@/components/base/forms/BaseTextarea'
import BaseButton from '@/components/base/buttons/BaseButton'
import BaseModal from '@/components/base/BaseModal'
import healthyHabitsRepository from '@/repositories/HealthyHabitsRepository'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import HealthyHabitsPredefined from '@/components/views/healthy-habits/HealthyHabitsPredefined'
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css'
import { BFormGroup, BFormCheckboxGroup, BFormRadio, BFormTimepicker, BInputGroupAppend, BInputGroupPrepend, BInputGroupText, BFormInput, BInputGroup, BTooltip, BFormCheckbox } from 'bootstrap-vue'
import { getWeekDaysNames } from '@/helpers/date.helpers'

const WEEKDAY_NAMES = getWeekDaysNames()

export default {
   name: 'healthyHabitsForm',
   components: {
    BaseCard,
    BaseInput,
    BaseButton,
    BaseModal,
    BFormGroup,
    BFormRadio,
    BFormTimepicker,
    BInputGroupAppend,
    BFormInput,
    BInputGroup,
    BFormCheckboxGroup,
    BTooltip,
    BInputGroupPrepend,
    BInputGroupText,
    VueClockPicker,
    HealthyHabitsPredefined,
    BaseTextArea,
    BFormCheckbox
   },
   props: {
    inModal: Boolean,
    habitDescription: String,
    loadHabitsOnSave: Boolean
   },
   created () {
    if (this.$store.state.healthyHabits.form.editing) {
        this.fillhealthyHabitsFields()
    } else if (this.$store.state.healthyHabits.form.predefinedHabit && Object.keys(this.$store.state.healthyHabits.form.predefinedHabit).length > 0) {
        this.loadPredefinedHabit()
    }
    if (this.$route.params.historyGroupId || this.$route.params.historyVarName) {
        this.loadPredefinedHabitFromHistory()
    }
		if (this.habitDescription) {
			this.healthyHabitsData.description = this.habitDescription
		}
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
        showFrequencyModal: false,
        showReminderDaysModal: false,
        showReminderDaysInput: false,
        goalDays: 1,
        goalWeek: 4,
        goalMonth: 2,
        frequencyText: null,
        reminderDaysText: null,
        reminderDaysArray: [],
        currentGoalFrequencyId: null,
        currentGoal: null,
        isMultiUser: false,
        weekDaysOptions: [
            {name: WEEKDAY_NAMES[0], value: 0},
            {name: WEEKDAY_NAMES[1], value: 1},
            {name: WEEKDAY_NAMES[2], value: 2},
            {name: WEEKDAY_NAMES[3], value: 3},
            {name: WEEKDAY_NAMES[4], value: 4},
            {name: WEEKDAY_NAMES[5], value: 5},
            {name: WEEKDAY_NAMES[6], value: 6}
        ],
        state: {
            description: null,
            question: null,
            reminder: null,
            notes: null,
            measureUnit: null,
            goalFrequencyId: null,
            goal: null,
            reminderDays: null
        },
        healthyHabitsData: {
            id: null,
            measurable: null,
            description: null,
            question: null,
            color: '#3238C4',
            measureUnit: null,
            goal: null,
            reminder: null,
            reminderDays: null,
            notes: null,
            goalFrequencyId: null,
            predefined: false,
            multiUsersEmailsOrPhones: []
        }
    }
   },
   computed: {
    showWeekDaysStacked () {
        return window.innerWidth < 720
    }
   },
   methods: {
    healthyHabitTypeSelected (measurable) {
        this.healthyHabitsData.measurable = measurable
        this.resetForm()
        setTimeout(() => {
            document.querySelector('.type-habit-form-box').scrollIntoView({ block: 'end', behavior: 'smooth' })
        }, 1)
    },
    setDefaultTime () {
        if (!this.healthyHabitsData.reminder) {
            this.healthyHabitsData.reminder = '00:00'
        }
    },
    resetReminder () {
        this.healthyHabitsData.reminder = null
        this.showReminderDaysInput = false
        this.reminderDaysText = null
        this.healthyHabitsData.reminderDays = null
        this.reminderDaysArray = []
    },
    checkValidMultiUserEmailOrPhone () {
        if (this.healthyHabitsData.multiUsersEmailsOrPhones.length === 0 || this.healthyHabitsData.multiUsersEmailsOrPhones.some(e => this.$validators.validate(e, ['email'], true) === false && this.$validators.validate(e, ['phone'], true) === false)) {
            return false
        }
        return true
    },
    switchInviteMultiUser () {
        if (!this.$store.state.healthyHabits.form.multiUser) {
            this.healthyHabitsData.multiUsersEmailsOrPhones = []
        }
    },
    sendData () {
        if (this.$store.state.healthyHabits.form.multiUser && !this.checkValidMultiUserEmailOrPhone()) {
            this.$store.dispatch('showInfoAlert', this.$t('checkInvalidMultiUserEmail'))
            return
        }
        if (this.$store.state.healthyHabits.form.multiUser && this.healthyHabitsData.multiUsersEmailsOrPhones.length > 9) {
            this.$store.dispatch('showInfoAlert', this.$t('multiUserInviteLimitExceeded'))
            return
        }
        let invalidData = false
        let objectKeys = Object.keys(this.state).filter(key => key !== 'notes' && key !== 'question' && key !== 'multiUsersEmailsOrPhones' && key !== 'reminder' && (this.healthyHabitsData.reminder ? true : key !== 'reminderDays') && (!this.healthyHabitsData.measurable ? key !== 'measureUnit' : true))
        if (!this.healthyHabitsData.color) {
            this.$store.dispatch('showInfoAlert', this.$t('mustSelectColor'))
            return
        }
        for (let key of objectKeys) {
            if (!this.healthyHabitsData[key] || this.state[key] === false) {
                this.state[key] = false
                invalidData = true
            }
        }
        if (invalidData) {
            this.$store.dispatch('showInfoAlert', this.$t('checkInvalidFormData'))
            return
        }
        if (this.$store.state.healthyHabits.form.editing) {
            healthyHabitsRepository.updateFormData(this.healthyHabitsData).then((response) => {
                if (response.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                    if (response.data.data) {
                        let currentItem = this.$store.state.healthyHabits.table.data.items.find(item => item.id === this.$store.state.healthyHabits.table.itemSelectedId)
                        currentItem.goal = this.healthyHabitsData.goal
                        currentItem.goalFrequencyId = this.healthyHabitsData.goalFrequencyId
                        let dataKeys = Object.keys(currentItem)
                        let serverData = response.data.data.filter(item => !dataKeys.some(key => key === this.getDateOnlyFormatted(item.date)))
                        for (let index in serverData) {
                            let item = serverData[index]
                            if (currentItem.measurable) {
                                currentItem[this.getDateOnlyFormatted(item.date)] = parseFloat(item.value)
                            } else {
                                currentItem[this.getDateOnlyFormatted(item.date)] = item.value === 'true' ? true : item.value === 'false' || item.value === 0 ? false : null
                            }
                        }
                        dataKeys = Object.keys(currentItem)
                        let dataMapped = dataKeys.filter(key => this.checkValidDate(key)).map(date => new Date(date))
                        if (!currentItem.measurable) {
                            this.fillPartialGoalCompleted(currentItem, new Date(Math.min(...dataMapped)))
                        }
                        this.updateGoalStreak(null, true)
                        currentItem.accumulatedGoal = this.lastGoalAccumulated(currentItem)
                    } else if (this.loadHabitsOnSave) {
                        this.getHealthyHabitsData()
                    }
                    this.cancel()
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                    this.cancel()
                }
            })
        } else {
            healthyHabitsRepository.createDataForm({...this.healthyHabitsData, historyVarName: this.$route.params.historyVarName, historyGroupId: this.$route.params.historyGroupId, historyPatientId: this.$route.params.historyPatientId}).then((response) => {
                if (response.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                    this.$emit('habitCreated', response.data[0])
                    this.cancel()
                    if (!this.isRouteFromClinicHistory() && this.loadHabitsOnSave) {
                        this.getHealthyHabitsData()
                    }
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                    this.cancel()
                }
            })
        }
    },
    cancel () {
        this.healthyHabitsData.measurable = null
        this.resetForm()
        this.$emit('closeModal')
    },
    checkValidField (key, constraint) {
        if (!this.healthyHabitsData[key] || this.$validators.validate(this.healthyHabitsData[key], [constraint], true) === false) {
            this.state[key] = false
        } else {
            this.state[key] = true
        }
        return this.state[key]
    },
    saveReminderDays () {
        if (this.reminderDaysArray.length === 0) {
            this.$store.dispatch('showInfoAlert', this.$t('mustSelectOption'))
            return
        }
        this.healthyHabitsData.reminderDays = this.reminderDaysArray.sort().map(index => getWeekDaysNames(false, true)[index]).join(',')
        this.reminderDaysText = this.reminderDaysArray.sort().map(index => WEEKDAY_NAMES[index]).join(', ')
        this.state.reminderDays = true
        this.showReminderDaysModal = false
    },
    saveFrequency () {
        if (!this.healthyHabitsData.goalFrequencyId) {
            this.$store.dispatch('showInfoAlert', this.$t('mustSelectOption'))
            return
        }
        if (!this.healthyHabitsData.measurable) {
            let value
            if (this.healthyHabitsData.goalFrequencyId === 1) {
                value = parseFloat(this.goalDays)
                if (!value || !Number.isInteger(value) || value < 1 || value > 90) {
                    this.$store.dispatch('showInfoAlert', `${this.$t('mustEnterValidInteger')} ${this.$t('between')} 1 ${this.$t('and')} 90`)
                    return
                }
                this.healthyHabitsData.goal = value
                this.frequencyText = this.healthyHabitsData.goal === 1 ? `${this.$t('daily')}` : `${this.$t('each')} ${this.healthyHabitsData.goal} ${this.$t('days')}`
            } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                value = parseFloat(this.goalWeek)
                if (!value || !Number.isInteger(value) || value < 1 || value > 6) {
                    this.$store.dispatch('showInfoAlert', `${this.$t('mustEnterValidInteger')} ${this.$t('between')} 1 ${this.$t('and')} 6`)
                    return
                }
                this.healthyHabitsData.goal = value
                this.frequencyText = this.healthyHabitsData.goal === 1 ? `${this.$t('weekly')}` : `${this.healthyHabitsData.goal} ${this.$t('timesToWeek')}`
            } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                value = parseFloat(this.goalMonth)
                if (!value || !Number.isInteger(value) || value < 1 || value > 29) {
                    this.$store.dispatch('showInfoAlert', `${this.$t('mustEnterValidInteger')} ${this.$t('between')} 1 ${this.$t('and')} 29`)
                    return
                }
                this.healthyHabitsData.goal = value
                this.frequencyText = this.healthyHabitsData.goal === 1 ? `${this.$t('monthly')}` : `${this.healthyHabitsData.goal} ${this.$t('timesToMonth')}`
            }
        } else {
            if (this.healthyHabitsData.goalFrequencyId === 1) {
                this.frequencyText = this.$t('daily')
            } else if (this.healthyHabitsData.goalFrequencyId === 2) {
                this.frequencyText = this.$t('weekly')
            } else if (this.healthyHabitsData.goalFrequencyId === 3) {
                this.frequencyText = this.$t('monthly')
            }
        }
        this.showFrequencyModal = false
        this.state.goalFrequencyId = true
    },
    resetForm () {
        this.healthyHabitsData.description = this.habitDescription || null
        this.healthyHabitsData.question = null
        this.healthyHabitsData.measureUnit = null
        this.healthyHabitsData.goal = null
        this.healthyHabitsData.goalFrequencyId = null
        this.healthyHabitsData.reminder = null
        this.healthyHabitsData.reminderDays = null
        this.healthyHabitsData.notes = null
        this.healthyHabitsData.predefined = false
        this.frequencyText = null
        for (let key of Object.keys(this.state)) {
            this.state[key] = null
        }
    },
    loadPredefinedHabit () {
        let predefinedHabit = this.$store.state.healthyHabits.form.predefinedHabit
        this.healthyHabitTypeSelected(predefinedHabit.measurable)
        this.healthyHabitsData.description = predefinedHabit.description
        this.healthyHabitsData.question = predefinedHabit.question
        this.healthyHabitsData.goal = predefinedHabit.goal ? predefinedHabit.goal : this.healthyHabitsData.goal
        this.healthyHabitsData.goalFrequencyId = predefinedHabit.goalFrequencyId
        this.healthyHabitsData.predefined = true
        this.healthyHabitsData.measureUnit = predefinedHabit.measurable ? predefinedHabit.measureUnit : null
        this.getHealthyHabitsFrequencyText()
        if (this.healthyHabitsData.goalFrequencyId === 1) {
            this.goalDays = this.healthyHabitsData.goal
        } else if (this.healthyHabitsData.goalFrequencyId === 2) {
            this.goalWeek = this.healthyHabitsData.goal
        } else if (this.healthyHabitsData.goalFrequencyId === 3) {
            this.goalMonth = this.healthyHabitsData.goal
        }
    },
    loadPredefinedHabitFromHistory () {
        this.healthyHabitsData.measurable = this.$route.params.healthyHabitMeasureUnit !== 'null'
        this.healthyHabitTypeSelected(this.healthyHabitsData.measurable)
        this.healthyHabitsData.description = this.$route.params.healthyHabitName
        this.healthyHabitsData.goalFrequencyId = parseInt(this.$route.params.healthyHabitFrequencyId)
        this.healthyHabitsData.measureUnit = this.healthyHabitsData.measurable ? this.$route.params.healthyHabitMeasureUnit : null
        this.healthyHabitsData.goal = !this.healthyHabitsData.measurable ? 1 : this.healthyHabitsData.goal
        this.getHealthyHabitsFrequencyText()
        if (this.healthyHabitsData.goalFrequencyId === 1) {
            this.goalDays = this.healthyHabitsData.goal
        } else if (this.healthyHabitsData.goalFrequencyId === 2) {
            this.goalWeek = this.healthyHabitsData.goal
        }
    },
    fillhealthyHabitsFields () {
        let item = this.$store.state.healthyHabits.table.data.items.find(item => item.id === this.$store.state.healthyHabits.table.itemSelectedId)
        this.healthyHabitsData.id = item.id
        this.healthyHabitsData.description = item.description
        this.healthyHabitsData.question = item.question
        this.healthyHabitsData.measureUnit = item.measureUnit
        this.healthyHabitsData.goal = item.goal
        this.healthyHabitsData.goalFrequencyId = item.goalFrequencyId
        this.currentGoalFrequencyId = item.goalFrequencyId
        this.currentGoal = item.goal
        this.healthyHabitsData.reminder = item.reminder
        this.healthyHabitsData.reminderDays = item.reminderDays
        this.healthyHabitsData.notes = item.notes
        this.healthyHabitsData.measurable = item.measurable
        this.healthyHabitsData.color = item.color
        this.isMultiUser = item.isMultiUser
        this.getHealthyHabitsFrequencyText()
        if (this.healthyHabitsData.reminderDays) {
            this.getHealthyHabitsReminderDaysText()
            this.showReminderDaysInput = true
        }
        if (item.goalFrequencyId === 1) {
            this.goalDays = item.goal
        } else if (item.goalFrequencyId === 2) {
            this.goalWeek = item.goal
        } else if (item.goalFrequencyId === 3) {
            this.goalMonth = item.goal
        }
    },
    getHealthyHabitsFrequencyText () {
        if (this.healthyHabitsData.goalFrequencyId === 1) {
            this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('daily') : this.healthyHabitsData.goal === 1 ? `${this.$t('daily')}` : `${this.$t('each')} ${this.healthyHabitsData.goal} ${this.$t('days')}`
        } else if (this.healthyHabitsData.goalFrequencyId === 2) {
            this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('weekly') : this.healthyHabitsData.goal === 1 ? `${this.$t('weekly')}` : `${this.healthyHabitsData.goal} ${this.$t('timesToWeek')}`
        } else if (this.healthyHabitsData.goalFrequencyId === 3) {
            this.frequencyText = this.healthyHabitsData.measurable ? this.frequencyText = this.$t('monthly') : this.healthyHabitsData.goal === 1 ? `${this.$t('monthly')}` : `${this.healthyHabitsData.goal} ${this.$t('timesToMonth')}`
        }
    },
    getHealthyHabitsReminderDaysText () {
        let reminderDays = this.healthyHabitsData.reminderDays.split(',').map(day => getWeekDaysNames(false, true).indexOf(day))
        this.reminderDaysArray = reminderDays
        this.reminderDaysText = reminderDays.map(index => WEEKDAY_NAMES[index]).join(', ')
    }
   }
}
</script>

<style lang="scss">
.type-habit-title {
    text-align: center;
}
.type-habit-option-selected {
    background-color: $blue !important;
    color: white;
    border: 0px !important;
    span{
        color: white;
    }
}
.type-habit-options-box {
    color: $blue;
    display: flex; 
    justify-content: center;
    text-align: center;
    // min-width: 309px;
}
.type-habit-form-box {
    display: flex; 
    justify-content: center;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    overflow: visible !important;
}
.input-modal-options {
    display: inline-block; 
    /* width: 35%; */
    width: 85px;
}
.form-check-input {
    position: initial !important;
    margin-right: 1rem !important;
}
.margin-bottom-form{
    margin-bottom: 1.5rem;
}
.margin-top-form{
    margin-top: 1.5rem;
}
.type-habit-form-box .input-group-append .btn-secondary{
    background-color: #8A8A8A;
    color: #eee;
}
.b-form-date-controls button{
    color: $blue;
    border-color: $blue;
}
.type-habit-form-box .form-control[readonly] {
    background-color: #eee;
    opacity: initial;
}
.type-habit-form-box [name="readonlymultiuser"] {
    background-color: rgba(138,138,138,0.5) !important;
    opacity: 1 !important;
}
.frequency-options-examples {
    color: black;
    font-size: 0.75rem;
}
.width-95{
    width: 95vw;
}
.no-margin-bottom{
    margin-bottom: 0px;
}
.reminder-input-form .input-group-prepend .input-group-text {
    border-top-right-radius: inherit !important;
    border-bottom-right-radius: inherit !important;
    border-left-width: 1px !important;
}
.clock-selector-input{
    width: 100%;
    background-color: #eee;
    border: none;
    font-size: 0.875rem;
    color: #8a8a8a;
    &::placeholder{
        opacity: 1;
    }
}
.reminder-container *{
    outline: none !important;
}
.type-habit-card{
    min-width: 135px;
    cursor: pointer;
    display: table;
}
.card-form-content{
    display: table-cell;
    vertical-align: middle;
}
.clock-picker__dialog-content{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsForm.vue